<template>
  <div
    ref="target"
    :class="{
      'right-0': isOpened,
      'right-[-80%]': !isOpened,
      'mobile-menu fixed top-0 h-screen w-4/5 overflow-y-auto bg-www-color-neutral-medium-dark transition-all duration-500': true,
      'flex flex-col': true,
    }"
  >
    <!-- Close Menu Button -->
    <div
      :class="{
        'colse-menu flex items-center justify-end py-5 pl-10 pr-25px text-right': true,
      }"
    >
      <button
        type="button"
        aria-label="Close Menu"
        @click="isOpened = false"
      >
        <PtcIcon
          name="ptc-close-menu"
          :class="{
            'text-www-color-white': true,
          }"
        />
      </button>
    </div>

    <!-- NavMenu Component -->
    <NavMenu
      v-if="menus"
      v-bind="props"
    />

    <!-- Buttons Container -->
    <div
      :class="{
        'flex flex-col gap-4 px-5 pb-4': true,
      }"
    >
      <SmallPrimaryButton
        v-bind="createStudentAccountButton"
        color="gray"
      />
      <SmallPrimaryButton
        v-bind="signupButton"
        :class="{
          'sign-up-mobile-button font-ptc-Rajdhani': true,
        }"
      />
      <AiSearchBar
        :mobile="true"
        :ai-advisor="aiAdvisor"
      />
    </div>
    <!-- Onshape Mobile App -->
    <div
      :class="{
        'mobile-app mx-auto mb-4 mt-auto flex flex-col text-10px font-normal leading-3 tracking-wider text-www-color-white': true,
      }"
    >
      <LanguageSelector />

      <div
        :class="{
          flex: true,
        }"
      >
        <p
          :class="{
            'mr-10px border-r border-www-color-neutral-medium pr-10px': true,
          }"
        >
          Download the Onshape Mobile App
        </p>
        <a
          href="https://apps.apple.com/us/app/onshape-3d-cad/id923421284"
          :class="{
            'text-www-color-primary-lighter': true,
          }"
          >IOS</a
        >
        <a
          href="https://play.google.com/store/apps/details?id=com.onshape.app&amp;hl=en_US&amp;gl=US"
          :class="{
            'pl-2 text-www-color-primary-lighter': true,
            'before:mr-2 before:h-10 before:w-10 before:content-[\'\']': true,
          }"
        >
          Android
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Header } from '~/sanity/types';
import { onClickOutside } from '@vueuse/core';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
import NavMenu from './NavMenu.vue';
import SmallPrimaryButton from './SmallPrimaryButton.vue';
import AiSearchBar from '../UtitlityBarComponent/AiSearchBar.vue';
import LanguageSelector from '../UtitlityBarComponent/LanguageSelector.vue';
const props = defineProps<Header>();

const isOpened = defineModel<boolean>('isOpened', {
  required: true,
  default: false,
});
const target = ref(null);
onClickOutside(target, () => {
  isOpened.value = false;
});
</script>
<style>
.sign-up-mobile-button a {
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
}
.sign-up-mobile-button img {
  display: none !important;
}
</style>
